<script>
  import { performance } from "../../firestore";
  import { onDestroy, onMount } from "svelte";
  import Steps from "./Steps.svelte";
  import Button from "../ui/Button.svelte";
  import {
    activeStep,
    productFileId,
    showModal,
    showLoading,
    comesFromUrl,
    get__store,
  } from "../../stores/mainStore";
  import {
    runStepperAction,
    sneakPeekSubmit,
    updateTexts,
    sendFeedback,
    track,
    setUserProperties,
  } from "../../helper/PostHelper";

  import { getUrlParam } from "../../helper/UIHelper";

  import DesignEdit from "../edit/DesignEdit.svelte";
  import SocialEdit from "../edit/SocialEdit.svelte";
  import TextsEdit from "../edit/TextsEdit.svelte";
  import FeatureEdit from "../edit/FeatureEdit.svelte";
  import CopyEdit from "../edit/CopyEdit.svelte";
  import ColorEdit from "../edit/ColorEdit.svelte";
  import LogoEdit from "../edit/LogoEdit.svelte";
  import HeroEdit from "../edit/HeroEdit.svelte";
  import EmailEdit from "../edit/EmailEdit.svelte";
  import Modal from "../container/Modal.svelte";
  import WebsiteEdit from "../edit/WebsiteEdit.svelte";
  import BusinessEdit from "../edit/BusinessEdit.svelte";
  import LastQuestion from "../edit/LastQuestion.svelte";
  import ThankYou from "../edit/ThankYou.svelte";
  import Error from "../edit/Error.svelte";
  import UrlEdit from "../edit/UrlEdit.svelte";

  import Loading from "../display/Loading.svelte";
  const previewMode = false; //true;//false;
  export let currentRoute;
  export let params;
  //export let showModal = false;
  let waitListTrackMode = "beforeFirstSneakPeek";
  const comesFromUrl_value = get__store(comesFromUrl);
  let steps = [
    {
      group: 0,
      modelKey: "product",
      comp: UrlEdit,
      action: "website",
    },
    {
      group: 0,
      modelKey: "design",
      comp: LogoEdit,
      action: "logoImage",
      nextButton: "Continue to Color",
      backButton: "Back",
    },
    {
      group: 0,
      modelKey: "design",
      comp: ColorEdit,
      action: "colorCode",
      nextButton: "Continue to Business",
      backButton: "Back",
    },
    {
      group: 0,
      modelKey: "product",
      comp: BusinessEdit,
      action: "bizNameType",
      nextButton: "Continue to Hero Image",
      backButton: "Back",
    },
    {
      group: 0,
      modelKey: "design",
      comp: HeroEdit,
      action: "generateSocial",
      nextButton: "Create My First Assets",
      backButton: "Back",
    },
    {
      group: 0,
      comp: DesignEdit,
      action: "designEdit",
      nextButton: "Continue to Business",
      backButton: "Back",
    },
    {
      group: 1,
      modelKey: "social",
      comp: SocialEdit,
      action: "firstSneakPeek",
      nextButton: "Let’s generate some text... and your website!",
      actionButton: "Nah, put me finally on the waiting list.",
    },
    {
      group: 2,
      modelKey: "texts",
      comp: TextsEdit,
      nextButton: "Continue to Feature",
      action: "clientDetails",
      backButton: "Back",
    },
    {
      group: 2,
      modelKey: "texts",
      comp: FeatureEdit,
      nextButton: "Generate Your Texts",
      action: "feature",
      backButton: "Back",
    },
    {
      group: 2,
      modelKey: "texts",
      comp: CopyEdit,
      nextButton: "Generate Your Website",
      action: "generateWebsite",
      backButton: "Back",
    },
    { group: 3, comp: WebsiteEdit },
    {
      group: 3,
      comp: LastQuestion,
      modelKey: "user",
      nextButton: "Send Feedback",
      action: "sendFeedback",
    },
    {
      group: 3,
      comp: ThankYou,
    },
    {
      group: 3,
      comp: Error,
      action: "reportError",
      nextButton: "Notify me when things are back up",
      actionButton: "Contact our friendly support",
    },
  ];

  let groups = [
    { name: "Your Design", nameShort: "Design", value: 0 },
    { name: "Your Sneak Peek", nameShort: "Social", value: 1 },
    { name: "Your Texts", nameShort: "Texts", value: 2 },
    { name: "Your Website & Profiles", nameShort: "Website", value: 3 },
  ];
  let activeStep_value;
  const handleSubmit = function () {
    //alert("submit");
    nextStep();
  };
  const nextStep = async function () {
    let tmpActiveStep = steps[activeStep_value];

    if (tmpActiveStep.action != null) {
      switch (tmpActiveStep.action) {
        case "logoImage":
          if (!previewMode) {
            track("in_logoImage", {
              input: model.design.logo != null ? "upload" : "default",
            });
          }
          activeStep.increment();
          break;
        case "colorCode":
          if (!previewMode) {
            track("in_colorCode", {
              input: model.design.mainColor.hex != null ? "manual" : "default",
            }); //TODO Detect manual change
          }
          activeStep.increment();

          break;
        case "bizNameType":
          if (!previewMode) {
            track("in_bizNameType");
            setUserProperties({ business_type: model.product.businessType });
          }
          activeStep.increment();

          break;
        case "designEdit":
          model.setViaUrl = true;
          steps[3].nextButton = "Create My First Assets";
          steps[3].action = "generateSocial";
          steps = steps;
          activeStep.set(3);
          break;
        case "generateSocial":
          if (model.setViaUrl) {
            activeStep.set(6);
          } else {
            if (tmpActiveStep.comp == HeroEdit) activeStep.increment();
            activeStep.increment();
          }

          showLoading.set(true);
          if (previewMode) {
            productFileId.set("cTToP5fyljI0Kw5QFM5B");

            setTimeout(() => {
              model.social = {
                previewUrlPaths: {
                  facebookCover:
                    "https://firebasestorage.googleapis.com/v0/b/saasmarketingformula.appspot.com/o/sneak-peek-users%2FGSMdtE58xMadXKp8gHSGrKAhLph2%2Fproducts%2FyAxhu7o0gxUNrunkaluZ%2FfacebookCover.png?alt=media&token=68a035b8-75a2-49bd-8cbf-b706d9d49f16",
                  instagramPost: `https://firebasestorage.googleapis.com/v0/b/saasmarketingformula.appspot.com/o/sneak-peek-users%2FGSMdtE58xMadXKp8gHSGrKAhLph2%2Fproducts%2FyAxhu7o0gxUNrunkaluZ%2FinstagramPost.png?alt=media&token=f7fd99aa-efe0-414e-82ee-16b5e2ea8817`,
                  email: `https://firebasestorage.googleapis.com/v0/b/saasmarketingformula.appspot.com/o/sneak-peek-users%2FGSMdtE58xMadXKp8gHSGrKAhLph2%2Fproducts%2FyAxhu7o0gxUNrunkaluZ%2Femail.png?alt=media&token=75494b83-1431-4cf7-8a89-230e9cf29b9d`,
                },
              };
              setTimeout(() => {
                showLoading.set(false);
              }, 1000);
            }, 5000);
          } else {
            track("in_heroImage", {
              input: model.design.hero != null ? "upload" : "default",
            });
            const trace = performance.trace("out_firstSneakPeek");
            trace.start();
            const response = await runStepperAction(
              tmpActiveStep.action,
              model
            ).catch((err) => {
              track("out_firstSneakPeek", { output: "error" });
              activeStep.set(steps.length - 1);
              // trace.stop();

              return;
            });
            trace.stop();
            let res = response;
            if (response.data != null) res = response.data;

            model.social.previewUrlPaths = res.previewUrlPaths;
            productFileId.set(res.productFileId);
            setTimeout(() => {
              track("out_firstSneakPeek", { output: "ok" });
              waitListTrackMode = "afterFirstSneakPeek";
              showLoading.set(false);
            }, 500);
          }

          break;
        case "firstSneakPeek":
          if (!previewMode) track("in_firstSneakPeek");
          activeStep.increment();

          break;
        case "clientDetails":
          if (!previewMode) {
            updateTexts(model.texts);
            track("in_clientDetails", {
              input:
                model.texts.gain != null ||
                model.texts.pain != null ||
                model.texts.persona != null
                  ? "manual"
                  : "default",
            });
          }

          activeStep.increment();

          break;
        case "feature":
          if (!previewMode) {
            updateTexts(model.texts);
            track("in_feature", {
              input: model.texts.feature != null ? "manual" : "default",
            });
          }
          activeStep.increment();

          break;
        case "generateWebsite":
          activeStep.increment();
          showLoading.set(true);
          if (previewMode) {
            model.website = {
              previewUrlPaths: {
                websiteHero:
                  "https://firebasestorage.googleapis.com/v0/b/saasmarketingformula.appspot.com/o/sneak-peek-users%2FGSMdtE58xMadXKp8gHSGrKAhLph2%2Fproducts%2FyAxhu7o0gxUNrunkaluZ%2FwebsiteHero.png?alt=media&token=2173a6df-6e8b-41dd-8794-19af53289479",
                productHunt: `https://firebasestorage.googleapis.com/v0/b/saasmarketingformula.appspot.com/o/sneak-peek-users%2FGSMdtE58xMadXKp8gHSGrKAhLph2%2Fproducts%2FyAxhu7o0gxUNrunkaluZ%2FproductHunt.png?alt=media&token=ff5bc8ba-d5bd-4881-b94b-215f6454ac5b`,
              },
            };
          } else {
            track("out_text", {
              input:
                model.texts.copies[0] == model.texts.benefit
                  ? "default"
                  : "switched",
            }); //TODO manual entry in future
            const trace_2 = performance.trace("out_secondSneakPeek");
            trace_2.start();
            await updateTexts(model.texts);
            const response_generateWebsite = await runStepperAction(
              tmpActiveStep.action,
              model
            ).catch((text_err) => {
              console.log("error creating website", text_err);
              track("out_secondSneakPeek", { output: "error" });
              // trace_2.stop();
              activeStep.set(steps.length - 1);
              return;
            });

            trace_2.stop();

            let res_generateWebsite = response_generateWebsite;
            if (response_generateWebsite.data != null)
              res_generateWebsite = response_generateWebsite.data;

            model.website.previewUrlPaths = res_generateWebsite.previewUrlPaths;
          }

          setTimeout(() => {
            waitListTrackMode = "afterSecondSneakPeek";
            track("out_secondSneakPeek", { output: "ok" });
            showLoading.set(false);
          }, 500);
          break;

        case "sendFeedback":
          if (!previewMode) {
            track("in_feedback");
            sendFeedback(model.user.feedbackBeforeState);
          }
          activeStep.increment();

          break;
        case "reportError":
          (waitListTrackMode = "afterError"), showModal.set(true);
          break;
      }
    } else {
      activeStep.increment();
    }
  };

  const action = function () {
    let tmpActiveStep = steps[activeStep_value];
    if (tmpActiveStep.action == "reportError")
      window.location.href = `mailto:support@getitout.io?subject=${encodeURIComponent(
        "GETitOUT had an error"
      )}&body=${encodeURIComponent(
        `I ran into an error while trying the GETitOUT Sneak Peek in step "${
          groups[steps[activeStep_value].group].name
        }" on ${new Date().toGMTString()}. Additional details:`
      )}`;
    else showModal.set(true);
  };

  const back = function () {
    let tmpActiveStep = steps[activeStep_value];
    if (tmpActiveStep.action != null) {
      switch (tmpActiveStep.action) {
        case "generateSocial":
          model.setViaUrl ? activeStep.set(5) : activeStep.decrement();
          break;
        case "designEdit":
          activeStep.set(0);
          break;
        default:
          activeStep.decrement();
          break;
      }
    } else activeStep.decrement();
  };

  const unsubscribe = activeStep.subscribe((value) => {
    activeStep_value = value;
  });

  const emailSaved = async () => {
    track("list_signup", { moment: waitListTrackMode });
    sneakPeekSubmit(model);
    activeStep.set(steps.length - 3);

    showModal.set(false);
  };

  async function getUrlData() {
    /*Reset Data*/
    model.design = {
      mainColor: { hex: null, rgbaObject: null },
      customColor: { hex: null, rgbaObject: null },
      logo: null,
      hero: null,
      images: [],
    };
    //TODO check if url exists
    if (model.product.website == "" || model.product.website == null) {
      activeStep.set(1);
      return;
    }
    showLoading.set(true);
    activeStep.set(5);

    if (previewMode) {
      model.product.website = "https://getitout.io";
    } else {
      track("in_webUrl");
      const trace = performance.trace("out_urlDesignExtraction");
      if (
        model.product.website.startsWith("https://") == false &&
        model.product.website.startsWith("http://") == false
      )
        model.product.website = `http://${model.product.website}`;

      trace.start();
      console.log("url hey", model.product.website);
      const response = await runStepperAction("getSneakPeekWebsiteInfos", {
        url: model.product.website,
      }).catch((err) => {
        track("out_urlDesignExtraction", { output: "error" });
        console.log(err);
        //trace.stop();
        //activeStep.set(steps.length - 1);
        comesFromUrl.set(false);
        activeStep.set(1);
        showLoading.set(false);
        return;
      });

      trace.stop();
      if (response == null) {
        track("out_urlDesignExtraction", { output: "error" });
        comesFromUrl.set(false);
        activeStep.set(1);
      } else {
        model.design.images = response.data.images;
        model.product.name = response.data.name;
      }

      setTimeout(() => {
        showLoading.set(false);
      }, 500);
    }
  }

  onMount(() => {
    if (comesFromUrl_value) {
      model.product.website = getUrlParam("url");
      if(model.product.website == null)
        model.product.website = getUrlParam("website");
      getUrlData();
    }
  });
  onDestroy(() => {
    unsubscribe();
  });

  let model = {
    setViaUrl: false,
    user: {
      email: null,
      firstName: null,
      feedbackBeforeState: "",
    },
    product: {
      name: null,
      businessType: null,
      website: null,
    },
    design: {
      mainColor: { hex: null, rgbaObject: null },
      customColor: { hex: null, rgbaObject: null },
      logo: null,
      hero: null,
      images: [],
    },
    social: {
      previewUrlPaths: {
        email: null,
        facebookCover: null,
        instagramPost: null,
      },
    },
    texts: {
      persona: null,
      feature: null,
      pain: null,
      gain: null,
      benefit: null,
      copies: [],
    },
    website: {
      previewUrlPaths: {
        websiteHero: null,
        productHunt: null,
      },
    },
  };
</script>

<div class="relative">
  <form on:submit|preventDefault={handleSubmit}>
    <div>
      <Steps
        steps={groups}
        isMobile={false}
        microsSteps={steps}
        class="w-full hidden lg:block lg:max-w-4xl absolute bg-white lg:h-12
        -top-128"
        style="left: 50%; transform: translate(-50%, 0);"
      />
      <Steps
        steps={groups}
        isMobile={true}
        microsSteps={steps}
        class="w-full lg:hidden bg-white mb-12"
      />
      {#each steps as step, i}
        {#if activeStep_value == i}
          <div>
            {#if step.modelKey != null}
              <svelte:component
                this={step.comp}
                bind:model={model[step.modelKey]}
                on:back={back}
                on:action={action}
                on:showMe={() => {
                  getUrlData();
                }}
                on:manually={() => {
                  activeStep.set(1);
                }}
              />
            {:else}
              <svelte:component
                this={step.comp}
                bind:model
                on:back={back}
                on:action={action}
                on:emailSubmit={emailSaved}
              />
            {/if}
          </div>
        {/if}
      {/each}
    </div>
    <div
      class="mt-6"
      class:lg:mt-16={activeStep_value != 6 &&
        activeStep_value != 5 &&
        activeStep_value != 11}
      class:sm:hidden={activeStep_value == 6 || activeStep_value == 5}
      class:hidden={$showLoading}
    >
      <div class="flex flex-row ">
        <span class="flex-grow" />
        {#if steps[activeStep_value].backButton != null}
          <Button class="mr-4" on:submit={back} raised={true}>
            {steps[activeStep_value].backButton}
          </Button>
        {/if}
        {#if steps[activeStep_value].nextButton != null}
          <Button type="submit" raised={true} primary={true}>
            {steps[activeStep_value].nextButton}
          </Button>
        {/if}
        <span class="flex-grow" />
      </div>

      <div class="flex flex-row mt-4">
        <span class="flex-grow" />
        {#if steps[activeStep_value].actionButton != null}
          <Button on:submit={action} raised={true}>
            {steps[activeStep_value].actionButton}
          </Button>
        {/if}
        <span class="flex-grow" />
      </div>
    </div>
  </form>
</div>

{#if $showModal}
  <Modal on:close={() => showModal.set(false)}>
    <EmailEdit bind:model={model.user} on:save={() => emailSaved()} />
  </Modal>
{/if}
<!-- {#if activeStep_value == steps.length - 4 && !$showLoading}
  <div
    class="bg-black sm:block hidden text-white shadow rounded-lg px-4 py-5 fixed
    bottom-6 left-1/2"
    style="width: calc(100vw - 4em);max-width: 32em;transform:translate(-50%, 0)">
    <EmailEdit
      bind:model={model.user}
      on:save={() => emailSaved()}
      darkMode={true} />
  </div>
{/if} -->
